<template>
  <div>
    <span>{{ attributeData.displayName }}</span>
    <v-text-field
      outlined
      :disabled="isLoading"
      :value="value"
      :error-messages="errorMessage"
      @change="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  name: 'attribute-field-STRING',
  props: {
    attributeData: {
      type: Object,
      default: () => {}
    },
    value: {
      type: String,
      default: null
    },
    errorMessage: {
      type: String,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  }
}
</script>
